Namespace 'Models.Parsers'

class Models.Parsers.InstagramMessageBaseParser
  canHandle: (messageJSON) ->
    throw new Error('Not implemented')

  parse: (messageJSON) ->
    throw new Error('Not implemented')

  _doParse: (builder, messageJSON) ->
    messaging = messageJSON.messaging[0]
    sender = messaging.sender
    recipient = messaging.recipient
    message = messaging.message
    builder.time = messageJSON.time
    builder.reactions = messageJSON.reactions || []
    builder.senderId = sender.id
    builder.recipientId = recipient.id
    builder.timestamp = messaging.timestamp
    builder.messageId = message.mid

  _getMessage: (messageJSON) ->
    messaging = messageJSON.messaging[0]
    messaging.message
